// extracted by mini-css-extract-plugin
module.exports = {"compactCalendar":"compactCalendar_compactCalendar___tLCK"};